<template>
	<tr class="position-relative">
		<slot />
	</tr>
</template>